import { createStore } from 'satcheljs';
var fileProviderStoreData = {
    fileProvidersViewState: [],
    addableFileProvidersViewState: [],
    isFileProvidersLoadingInProgress: false,
    areFileProvidersLoaded: false,
};
var fileProviderStore = createStore('fileProviderStore', fileProviderStoreData)();
export default fileProviderStore;
//# sourceMappingURL=store.js.map